import { ADDRESS_CHANGE, RESET_ADDRESS } from "../constants";

export const handleTextChange = (name, value, status) => ({
  type: ADDRESS_CHANGE,
  name,
  value,
  status
});
export const resetAddress = () => ({ type: RESET_ADDRESS });
